// src/services/whatsappRequestService.ts
// ============================================================================
// SOLICITUD DE ACTIVACIÓN DE WHATSAPP ("bajo solicitud") — re-cableado a lealify-base.
// ============================================================================
// Antes escribía en Firestore (businesses.whatsappRequested + colección whatsappRequests,
// que un watcher de server4 leía para avisar a Carlos). Ahora todo es server-side:
// POST /messages/whatsapp/request encola la solicitud y avisa a Carlos por WhatsApp
// (lib/whatsapp.notifyAdmin). El estado 'pending' se refleja luego en
// currentUser.whatsappRequested (buildUser ← /messages/whatsapp-status).
//
// Se conserva la firma requestWhatsappActivation(user) para no tocar WhatsAppRequestPanel.
import { whatsappApi } from '../api/whatsappApi';
import type { User } from '../types/user';

export async function requestWhatsappActivation(user: User): Promise<void> {
  const res = await whatsappApi.requestActivation(user?.phoneNumber || null);
  if (!res?.ok) throw new Error('No se pudo enviar la solicitud.');
}
